import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

const ImageWrapper = React.forwardRef((props, ref) => {

    const windowData = useSelector(state => state.window);
    const dispatch = useDispatch();
    const [imageSrc, setImageSrc] = useState(props.set.default);

    useEffect(()=>{

        let set = {...props.set}
        let sizeFound = false;
        let sourceFound = set['default'];
        for (let [key, value] of Object.entries(set)) {
            if(key !== 'default' && !sizeFound && windowData.width < parseInt(key)) {
                sizeFound = true;
                sourceFound = value;
            }
        }

        if(sourceFound !== imageSrc && (props.scaleDown || windowData.increase)) setImageSrc(sourceFound);

    }, [windowData,props,imageSrc])

    useEffect(()=>{
        dispatch({ type: "NEW_ASSET", payload: props.set.default });
    },[dispatch, props.set])


    function loaded(){
        /** moment delay to make sure it's not removed before other assets are in the mix, ie. countdown complete before starting **/
        setTimeout(()=>{
            dispatch({ type: "ASSET_LOADED", payload: props.set.default });
        }, 500)

    }

    useEffect(()=>{
        /** moment delay to make sure it's not removed before other assets are in the mix, ie. countdown complete before starting **/
        setTimeout(()=>{
            if (ref && ref.complete) dispatch({ type: "ASSET_LOADED", payload: props.set.default });
        }, 500)
    }, [dispatch, ref, props.set.default])

    function loadImage(){
        if(imageSrc){
            let attrs = {...props};
            if (!props.alt) attrs.alt = '';
            if (props.scaleDown) delete attrs.scaleDown;
            // if (!props.ref) attrs.ref = ref; //forwarded properly
            return <img {...attrs} ref={ref} onLoad={loaded} src={imageSrc}  alt={attrs.alt}/>
        } else return <></>
    }

    return loadImage();
        
});

export default ImageWrapper
